<template>
  <li id="up-nav-bar-options" @click="emit('click')">
    <div
      class="h-14 flex pt-4 pb-5 cursor-pointer text-slate-500 font-medium text-sm hover:text-slate-900 relative select-none"
    >
      <div
        :class="[
          'flex items-center',
          'navbar-option__text',
          { ['text-slate-900']: isActive },
        ]"
      >
        {{ displayText }}
        <div v-if="hasDropdownOptions" class="navbar-option__icon pt-1">
          <Icon
            name="material-symbols:keyboard-arrow-down"
            size="1.25rem"
            class="ml-1"
          />
        </div>
      </div>
      <div
        :class="[
          { ['hidden']: !isActive },
          'navbar-option__highlight w-full h-1 rounded-t bg-secondary-700 absolute bottom-0 left-0',
        ]"
      ></div>
    </div>
  </li>
</template>

<script setup lang="ts">
defineProps<{
  displayText: string;
  isActive: boolean;
  hasDropdownOptions?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>
